import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { paths } from '@app/constants';
import { environment } from '@env/index';
import { Globals } from '@app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class AxiomGuard implements CanActivate {
  config = environment;
  constructor(
    private router: Router,
    private globals: Globals
  ) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (route.data.component === 'CHARTS_STORE') {
      return this.handleAxiomDetectLoadChartStore();
    } else if (route.data.component === 'CHARTS_MANAGER' || route.data.component === 'SIGN_IN') {
      return this.handleAxiomDetectLoadChartManager();
    } else if (route.data.component === 'PAGE_NOT_FOUND') {
      return this.handleAxiomDetectLoadPageNotFound();
    } else if (route.data.component === 'SUPPORT') {
      return this.handleAxiomDetectLoadPageNotFound();
    } else if (route.data.component === 'HEALTH') {
      return this.handleAxiomDetectLoadPageNotFound();
    } else if (route.data.component === 'VERSION') {
      return this.handleAxiomDetectLoadPageNotFound();
    } else if (route.data.component === 'OVERVIEW') {
      return this.handleAxiomDetectLoadPageNotFound();
    } else if (route.data.component === 'HOW_TO_GUIDE'){
      return this.handleAxiomDetectLoadPageNotFound();
    } else if (route.data.component === 'PAYMENT') {
      return this.handleAxiomDetectLoadPageNotFound();
    }
  }

  handleAxiomDetectLoadChartStore = (): boolean => {
    if (this.config.axiomChartStoreFlag === '0') {
      return true;
    } else {
      return this.axiomDeviceDetector();
    }
  }

  handleAxiomDetectLoadChartManager = (): boolean => {
    if (this.config.axiomChartManagerFlag === '0') {
      return true;
    } else {
      return this.axiomDeviceDetector();
    }
  }

  handleAxiomDetectLoadPageNotFound = (): boolean => {
    if (this.config.axiomChartManagerFlag === '0' || this.config.axiomChartStoreFlag === '0') {
      return true;
    } else {
      return this.axiomDeviceDetector();
    }
  }

  axiomDeviceDetector = (): boolean => {
    if (this.globals.isAxiom) {
      this.globals.isActive = false;
      this.router.navigate([paths.AXIOM_PAGE], { replaceUrl: false });
      return false;
    }
    this.globals.isActive = true;
    return true;
  }
}
